import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { CloseCross, Edit } from '../../icons';
import { IconButton } from '../IconButton';
import { Column } from '../Layout';
import { Separator } from '../Separator';
import { Typography } from '../Typography';
import styles from './MobileSummaryCard.module.scss';
function renderActionIcon(action) {
    switch(action.type){
        case 'edit':
            return /*#__PURE__*/ _jsx(Edit, {
                size: 18
            });
        case 'remove':
            return /*#__PURE__*/ _jsx(CloseCross, {
                size: 14
            });
    }
}
export function MobileSummaryCard(props) {
    const { testId, title, items, titleTestId } = props;
    return /*#__PURE__*/ _jsxs(Column, {
        className: styles.root,
        gap: 8,
        testId: testId,
        children: [
            title && /*#__PURE__*/ _jsx(Typography, {
                ellipsis: true,
                skin: "secondary",
                testId: titleTestId,
                children: title
            }),
            (items || []).map((item, index)=>/*#__PURE__*/ _jsxs(Fragment, {
                    children: [
                        index > 0 && !item.hideSeparator && /*#__PURE__*/ _jsx(Separator, {
                            spacing: "none",
                            height: "100%",
                            skin: "light",
                            testId: testId ? "".concat(testId, "-separator-").concat(index) : undefined
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.contentWrapper,
                            children: [
                                /*#__PURE__*/ _jsxs(Typography, {
                                    ellipsis: true,
                                    className: styles.content,
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            skin: "secondary",
                                            testId: item.titleTestId,
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            ellipsis: item.bodyEllipsis,
                                            testId: item.bodyTestId,
                                            children: item.body
                                        })
                                    ]
                                }),
                                item.actions && /*#__PURE__*/ _jsx("div", {
                                    className: styles.actions,
                                    children: item.actions.map((action, index)=>/*#__PURE__*/ _jsx(IconButton, {
                                            noPadding: true,
                                            type: "button",
                                            size: "smallMedium",
                                            className: styles.editButton,
                                            onClick: action.onClick,
                                            testId: action.testId,
                                            children: renderActionIcon(action)
                                        }, index))
                                })
                            ]
                        })
                    ]
                }, index))
        ]
    });
}
